var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"maintenance_container"}},[_c('MainTitle'),_c('h3',[_vm._v("We are currently undergoing maintenance")]),_c('img',{attrs:{"src":_vm.img,"width":"30%"}}),_c('h3',[_vm._v("Please check back later")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }